export default __webpack_public_path__ + "4d90ca45059d898158f60bb6ad30abfd.obj";